import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';

export namespace DoppeActionTypeWhatsappButton {

    export interface ActionSettings {
        phone: string;
        showContactPanel: boolean
    }
}

export const doppeActionTypeWhatsappButton = doppeActionTypeDefineMetadata<DoppeActionTypeWhatsappButton.ActionSettings>({
    id: 'io.bymo.action/whatsapp-button',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        phone: '',
        showContactPanel: false,
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            phone: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
});
